import styled from '@emotion/styled';
import * as React from 'react';
import { useState } from 'react';
import { BLOG_POST_CATEGORIES, BLOG_POSTS } from './shared/blog';
import { BlogCardWidget } from './shared/BlogCardWidget';
import { PageWidget } from '../../widgets/layout/PageWidget';
import { CardGridWidget } from '../../widgets/CardGridWidget';
import { SelectionPillWidget } from '../../widgets/SelectionPillWidget';
import { ContentWidget } from '../../widgets/ContentWidget';
import { BLOG_CATEGORY_TONES, BlogCategory } from './shared/blogCategories';

export const BlogPostsPage: React.FC = () => {
  const [category, setCategory] = useState<BlogCategory | null>(null);
  const posts = category ? BLOG_POSTS.filter((post) => post.categories.includes(category)) : BLOG_POSTS;

  return (
    <PageWidget width={1240} title="Blog">
      <S.Header>
        <h1>Blog</h1>
        <p>Product news, practical guides, and perspectives from JourneyApps.</p>
      </S.Header>
      <S.Categories aria-label="Filter blog posts">
        <SelectionPillWidget
          type="radio"
          name="blog-category"
          checked={category === null}
          onChange={() => setCategory(null)}
          tone="insights"
        >
          All
        </SelectionPillWidget>
        {BLOG_POST_CATEGORIES.map((item) => (
          <SelectionPillWidget
            key={item}
            type="radio"
            name="blog-category"
            tone={BLOG_CATEGORY_TONES[item]}
            showTone
            checked={category === item}
            onChange={() => setCategory(item)}
          >
            {item}
          </SelectionPillWidget>
        ))}
      </S.Categories>
      <S.Posts>
        {posts.map((post) => (
          <BlogCardWidget post={post} key={post.frontmatter.permalink} />
        ))}
      </S.Posts>
    </PageWidget>
  );
};
namespace S {
  export const Header = styled(ContentWidget)`
    margin-bottom: 30px;
  `;

  export const Posts = styled(CardGridWidget)`
    margin-top: 30px;
  `;

  export const Categories = styled.div`
    display: flex;
    column-gap: 10px;
    row-gap: 10px;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
  `;
}
